import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Layout } from "antd";
import { Navbar } from "./Navbar";
import { Sidebar, type MenuItem } from "./Sidebar";
import { Breadcrumb } from "./Breadcrumb";

const { Content } = Layout;

interface MainLayoutProps {
  children: React.ReactNode;
  menuItems: MenuItem[];
  title?: string;
}

export function MainLayout({ children, menuItems, title }: MainLayoutProps) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { pathname } = useLocation();
  const hideBreadcrumb = pathname === "/dashboard";

  const handleCollapse = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <Layout className="min-h-screen h-screen">
      {/* Navbar */}
      <Navbar title={title} onCollapse={handleCollapse} />

      <Layout className="flex-1">
        {/* Sidebar - Desktop */}
        <div className="hidden lg:block h-full">
          <Sidebar
            items={menuItems}
            collapsed={sidebarCollapsed}
            onCollapse={handleCollapse}
            className="h-full"
          />
        </div>

        {/* Main Content */}
        <Content className="p-4 lg:p-6 overflow-auto flex-1 relative z-10">
          {!hideBreadcrumb && <Breadcrumb />}
          {children}
        </Content>
      </Layout>
    </Layout>
  );
}
